import axios from "axios";
import { API } from "../../../config";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../configureStore";

export const createSharedResult = createAsyncThunk(
  "SharedResultReducer/createSharedResult",
  async (arg: { token: string; locale: string; itemId: string }, store) => {
    try {
      const response = await axios.post(
        `${API}/portal/shared-result`,
        { itemId: arg.itemId },
        {
          headers: {
            Authorization: `Bearer ${arg.token}`,
            "Accept-Language": `${arg.locale}`,
          },
        },
      );
      return store.fulfillWithValue(response.data);
    } catch (error: any) {
      return store.rejectWithValue(
        error.response?.data ?? error.request?.response ?? error.message,
      );
    }
  },
);

export const fetchSharedResult = createAsyncThunk(
  "SharedResultReducer/fetchSharedResult",
  async (arg: { id: string }, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;

    try {
      const response = await axios.get(
        `${API}/portal/shared-result/${arg.id}`,
        {
          headers: {
            "Accept-Language": locale,
          },
        },
      );
      const { data } = response;

      return store.fulfillWithValue(data);
    } catch (error: any) {
      return store.rejectWithValue({
        message:
          error.response?.data ?? error.request?.response ?? error.message,
        status: error.response?.status ?? null,
      });
    }
  },
);
